import { AnyAction } from '@reduxjs/toolkit';
import { injectStoresData, injectStoresReducer } from '../../state';
import { slice } from './actions';
import { STORE_NAME, AlertStorage } from './private';

export function getStore(): AlertStorage {
    const globalStore = injectStoresData().store.getState();
    const data: AlertStorage | undefined = (globalStore as any)[STORE_NAME];
    return data ?? [];
}

export function setupStore() {
    const reducerRegister = injectStoresReducer();
    reducerRegister.addSlice(slice);
}

export function dispatchAction(action: AnyAction) {
    const store = injectStoresData();
    store.dispatch(action);
}
